/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TestStatusEnum } from './test-status-enum';

export interface DeckInvestmentCompany {
  readonly id: string;
  readonly name: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly total_investment: number;
  readonly red: boolean;
  readonly test_status: TestStatusEnum;
  readonly has_agreement: boolean;
}
export namespace DeckInvestmentCompany {}
